import { PaymentsProps } from '../icon-types';
import { SvgWrapper } from '../svg-wrapper/payment-wrapper';

export function VisaIcon(props: PaymentsProps) {
  return (
    <SvgWrapper {...props}>
      <g fill="none" fillRule="evenodd">
        <rect
          x={0.5}
          y={0.5}
          width={35}
          height={23}
          rx={4}
          fill="#FFF"
          stroke="#CFD4D9"
        />
        <g fillRule="nonzero">
          <path
            d="m17.872 8.095-1.32 7.72h-2.11l1.32-7.72h2.11Zm3.351 0c.774 0 1.4.167 1.795.318l-.272 1.614-.181-.08a3.505 3.505 0 0 0-1.491-.286c-.79 0-1.145.326-1.153.644 0 .35.429.58 1.129.922 1.153.533 1.688 1.185 1.68 2.035-.016 1.55-1.383 2.552-3.483 2.552-.898-.008-1.763-.19-2.233-.397l.28-1.678.264.12c.65.278 1.079.397 1.878.397.576 0 1.194-.23 1.202-.731 0-.326-.263-.565-1.038-.93-.757-.358-1.77-.954-1.754-2.028.009-1.454 1.4-2.472 3.377-2.472Zm4.754 4.985.763-2.16c-.008.017.157-.452.252-.739l.133.665s.362 1.848.441 2.234h-1.59Zm2.36-4.985h-1.48c-.455 0-.802.14-.999.64l-2.84 7.08h2.007s.33-.953.4-1.159h2.456c.055.271.228 1.158.228 1.158h1.77l-1.542-7.719Zm-15.953 0-1.906 5.27-.208-1.07c-.352-1.232-1.457-2.572-2.69-3.238l1.745 6.757h2.058l3.058-7.719h-2.057Z"
            fill="#00579F"
          />
          <path
            d="M8.871 8.095H6.03L6 8.255c2.217.654 3.685 2.232 4.288 4.129l-.617-3.626c-.102-.503-.415-.646-.8-.663Z"
            fill="#FAA61A"
          />
        </g>
      </g>
    </SvgWrapper>
  );
}
